import React, { useEffect, useState } from "react";
import {
  abhaSuggestionsServices,
  abhaCreateServices,
  UpdateAbhaUserServices,
} from "../../services";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import abdm_config from "../../config";
import Modal from "react-modal";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

Modal.setAppElement("#root");

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const AbhaSuggestions = ({
  setAdhaaddress,
  setMobileVerificationOTPSent1,
  setCurrentStep,
}) => {
  // ── All state & logic — unchanged ──
  const [abhaaddress, setAbhaaddress] = useState("");
  const [suggestionList, setsuggestionList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userInfo = useSelector((state) => state.user.patientDetails);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patientData = JSON.parse(localStorage.getItem("selectedIndex"));

    try {
      const body = {
        referenceId: uuidv4(),
        txnId: localStorage.getItem("txnId"),
        abhaAddress: abhaaddress,
        mobile: userInfo.mobile,
        xToken: userInfo.xToken,
      };
      if (patientData?.pId) {
        body.patientId = patientData.pId;
      }
      const response = await abhaCreateServices({ body });
      console.log("ABHA Create Response:", response);

      if (!response?.status) {
        toast.error(
          response?.result?.error?.message ||
            response?.message ||
            "Failed to create ABHA Address"
        );
        return;
      }
      localStorage.setItem("userData", JSON.stringify(response?.result));
      setCurrentStep("AbhaCard");
    } catch (error) {
      console.error("Error while creating ABHA:", error);
      toast.error(
        error?.message ||
          "Something went wrong while creating ABHA. Please try again."
      );
    }
  };

  const getsuggesion = async () => {
    try {
      const body = {
        txnId: localStorage.getItem("txnId"),
      };
      const response = await abhaSuggestionsServices({ body });
      if (response.status) {
        let suggestiondata = response.result.abhaAddressList;
        setsuggestionList(suggestiondata);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  useEffect(() => {
    getsuggesion();
  }, []);

  // ── Design: lmop layout (same as AbhaCard / AbhaCardUI) ──
  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">
              Ayushman Bharat Digital Mission (ABDM)
            </span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Form Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Choose your ABHA Address</h3>
                  <p className="lmop-card-subtitle">
                    Choose or enter a unique ABHA address to continue.
                  </p>

                  <form onSubmit={handleSubmit} className="pt-2">

                    {/* Input + suffix */}
                    <div className="d-flex align-items-center mb-1">
                      <input
                        type="text"
                        className="form-control suggestion-input"
                        placeholder="Enter your ABHA"
                        value={abhaaddress}
                        autoComplete="off"
                        onChange={(e) => setAbhaaddress(e.target.value)}
                      />
                      <p className="patient-name suggestion-input-placeholder mb-0">
                        {abdm_config.abdm_env}
                      </p>
                    </div>

                    {/* Validation rules link */}
                    <a
                      type="button"
                      className="view-abha d-block mb-3"
                      onClick={openModal}
                      style={{ cursor: "pointer" }}
                    >
                      View the ABHA Validation Rules
                    </a>

                    {/* Suggestions */}
                    <p className="pb-1 mb-1" style={{ fontWeight: 500 }}>
                      Suggestions:
                    </p>
                    <div className="suggestion-profile mb-3">
                      {suggestionList?.map((suggestion, index) => (
                        <div
                          key={index}
                          onClick={() => setAbhaaddress(suggestion)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center suggestion p-2 mb-2 rounded">
                            <h5 className="mb-0 suggestion-address">
                              {suggestion}
                              {abdm_config.abdm_env}
                            </h5>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Submit */}
                    <button type="submit" className="lmop-continue-btn">
                      Continue
                    </button>
                  </form>

                  {/* NHA row */}
                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Validation Rules Modal — logic unchanged ── */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="ABHA Validation Rules"
        className="custom-modal"
        overlayClassName="custom-overlay"
      >
        <button className="modal-close-icon" onClick={closeModal}>
          &times;
        </button>
        <h2>ABHA Address Validation Rules</h2>
        <ul>
          <li>Minimum length - 8 characters</li>
          <li>Maximum length - 18 characters</li>
          <li>Allowed special characters: 1 dot (.) and/or 1 underscore (_)</li>
          <li>
            Special characters must be in between. Not at the beginning or end.
          </li>
          <li>
            Alphanumeric: only letters, only numbers, or a combination of both.
          </li>
        </ul>
      </Modal>
    </>
  );
};

export default AbhaSuggestions;
